import React, { useState, useEffect } from "react";
import { RangeSlider } from "rsuite";
import { Values } from "../models/API";
import { exportFilterStateToSQ } from "../helpers/dynamicFilterSQ";
import { toggleVisibility } from "../helpers/shared";
import { Tooltip } from "./Tooltip";

interface SliderFilterProps {
  name: string;
  id: string;
  values: Values[];
  key: string;
  dataState: any;
  setDataState: any;
  tooltip: string;
}

type SliderValue = [number, number];

let sliderDataToSend = 0;
const sliderTimeout = 1000;

export const SliderFilter = (props: SliderFilterProps) => {
  const initialValue: SliderValue = [props.values[0].Min, props.values[0].Max];
  const [sliderState, setSliderState] = useState<SliderValue>(initialValue);
  const [input, setInput] = useState([
    initialValue[0].toString(),
    initialValue[1].toString(),
  ]);

  useEffect(() => {
    const indexInDataState = props.dataState.Dynamic.findIndex(
      (x) => x.Key === props.id
    );
    if (indexInDataState >= 0) {
      const newDataState: SliderValue = [
        props.dataState.Dynamic[indexInDataState].FromValue,
        props.dataState.Dynamic[indexInDataState].ToValue,
      ];
      setSliderState(newDataState);
    }
  }, [props.dataState, props.id]);

  const setValueOnSliderAndInState = (value: SliderValue) => {
    setSliderState(value);
    setInput([value[0].toString(), value[1].toString()]);
    const actualDataObj = { ...props.dataState };
    const actualArrElIndex = actualDataObj.Dynamic.findIndex(
      (x) => x.Key === props.id
    );
    actualDataObj.Dynamic[actualArrElIndex] = {
      Key: props.id,
      FromValue: value[0],
      ToValue: value[1],
    };
    window.clearTimeout(sliderDataToSend);
    sliderDataToSend = window.setTimeout(() => {
      exportFilterStateToSQ(actualDataObj);
      props.setDataState(actualDataObj);
    }, sliderTimeout);
  };

  // Just update input value
  const onChangeFrom = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = ev.target.value;
    const _regexp = /^[\d]+\.?[\d]*$/g;
    if (_regexp.test(inputValue) || !inputValue) {
      setInput([inputValue, input[1]]);
    }
  };
  // Perform some checks against mx/min
  const onBlurFrom = (ev: React.FocusEvent<HTMLInputElement>) => {
    const inputValue = ev.target.value;
    const _regexp = /^[\d]+\.?[\d]*$/g;
    if (!inputValue) {
      // Empty so update with initial min
      setValueOnSliderAndInState([initialValue[0], sliderState[1]]);
    } else if (_regexp.test(inputValue)) {
      let _val = parseFloat(inputValue);
      // Must be in range
      if (_val < initialValue[0]) {
        _val = initialValue[0];
      }
      if (_val > initialValue[1]) {
        _val = initialValue[1];
      }
      // Modify TO value if FROM value is larger
      setValueOnSliderAndInState([
        _val,
        _val > sliderState[1] ? _val : sliderState[1],
      ]);
    }
  };

  // Just update input value
  const onChangeTo = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = ev.target.value;
    const _regexp = /^[\d]+\.?[\d]*$/g;
    if (_regexp.test(inputValue) || !inputValue) {
      setInput([input[0], inputValue]);
    }
  };
  // Perform some checks against mx/min
  const onBlurTo = (ev: React.FocusEvent<HTMLInputElement>) => {
    const inputValue = ev.target.value;
    const _regexp = /^[\d]+\.?[\d]*$/g;
    if (!inputValue) {
      // Empty so update with initial max
      setValueOnSliderAndInState([sliderState[0], initialValue[1]]);
    } else if (_regexp.test(inputValue)) {
      let _val = parseFloat(inputValue);
      // Must be in range
      if (_val < initialValue[0]) {
        _val = initialValue[0];
      }
      if (_val > initialValue[1]) {
        _val = initialValue[1];
      }
      // Modify FROM value if TO value is smaller
      setValueOnSliderAndInState([
        _val < sliderState[0] ? _val : sliderState[0],
        _val,
      ]);
    }
  };

  return (
    <div className="filter-group">
      <h3 onClick={toggleVisibility}>
        {props.name}
        {props.tooltip && <Tooltip htmlString={props.tooltip} />}
      </h3>
      <div className="slider">
        <div className="numbers">
          {initialValue[0]}
          {props.values[0].Text} — {initialValue[1]}
          {props.values[0].Text}
        </div>
        <div className="inputs">
          <input
            type="text"
            value={input[0]}
            onChange={onChangeFrom}
            onBlur={onBlurFrom}
          />
          <input
            type="text"
            value={input[1]}
            onChange={onChangeTo}
            onBlur={onBlurTo}
          />
        </div>
        <div className="content">
          <RangeSlider
            min={initialValue[0]}
            max={initialValue[1]}
            step={props.values[0].Step}
            value={[sliderState[0], sliderState[1]]}
            handleClassName="handle_1"
            tooltip={false}
            onChange={setValueOnSliderAndInState}
          />
        </div>
      </div>
    </div>
  );
};
